import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericChart = _resolveComponent("GenericChart")!
  const _component_EmptyChartState = _resolveComponent("EmptyChartState")!

  return (_openBlock(), _createBlock(_component_EmptyChartState, {
    options: _ctx.chartOptions,
    class: "w-full grid"
  }, {
    default: _withCtx(() => [
      (_ctx.chartOptions)
        ? (_openBlock(), _createBlock(_component_GenericChart, {
            key: 0,
            options: _ctx.chartOptions
          }, null, 8, ["options"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["options"]))
}